import { createAction, handleActions } from 'redux-actions';
import * as R from 'ramda';
import { EditorState, ContentState } from 'draft-js';

export const types = {
  specsheetSetValues: 'SPECSHEET_SET_VALUES',
  specsheetUpdateSpecsheets: 'SPECSHEET_UPDATE_SPECSHEETS',
  specsheetSetSpecsheets: 'SPECSHEET_SET_SPECSHEETS',
  specsheetSetSpecsheet: 'SPECSHEET_SET_SPECSHEET',
  specsheetHandleForm: 'SPECSHEET_HANDLE_FORM',
  specsheetSaved: 'SPECSHEET_SAVED',
  specsheetSelectSpanType: 'SPECSHEET_SELECT_SPAN_TYPE',
  specsheetSelect: 'SPECSHEET_SELECT',
  specsheetTakePhoto: 'SPECSHEET_TAKE_PHOTO',
  specsheetGalleryPhoto: 'SPECSHEET_GALLERY_PHOTO',
  specsheetDeletePhoto: 'SPECSHEET_DELETE_PHOTO',
  specsheetPhotoDeleted: 'SPECSHEET_PHOTO_DELETED',
  specsheetSavePhoto: 'SPECSHEET_SAVE_PHOTO',
  specsheetPhotoSaved: 'SPECSHEET_PHOTO_SAVED',
  specsheetSetCurrentImage: 'SPECSHEET_SET_CURRENT_IMAGE',
  specsheetSVGClick: 'SPECSHEET_SVG_CLICK',
  specsheetSetOpenDropdown: 'SPECSHEET_SET_OPEN_DROPDOWN',
  specsheetSVGClickOpen: 'SPECSHEET_SVG_CLICK_OPEN',
  specsheetSetActiveTabKey: 'SPECSHEET_SET_ACTIVE_TAB_KEY',
  specsheetToggleOvalPreview: 'SPECSHEET_TOGGLE_OVAL_PREVIEW',
  specsheetCalculateThumbCuts: 'SPECSHEET_CALCULATE_THUMB_CUTS',
  specsheetAddThumbCut: 'SPECSHEET_ADD_THUMB_CUT',
  specsheetUpdateThumbCut: 'SPECSHEET_UPDATE_THUMB_CUT',
  specsheetDeleteThumbCut: 'SPECSHEET_DELETE_THUMB_CUT',
  specsheetSetThumbCuts: 'SPECSHEET_SET_THUMB_CUTS',
  specsheetSetThumbCutsError: 'SPECSHEET_SET_THUMB_CUTS_ERROR',
  specsheetAddNew: 'SPECSHEET_ADD_NEW',
  specsheetClone: 'SPECSHEET_CLONE',
  specSheetRemove: 'SPECSHEET_REMOVE',
  specSheetRemoved: 'SPECSHEET_REMOVED',
  specSheetNoteState: 'SPECSHEET_NOTE_STATE',
};

export const specsheetSetValues = createAction(types.specsheetSetValues);
export const specsheetUpdateSpecsheets = createAction(types.specsheetUpdateSpecsheets);
export const specsheetSetSpecsheets = createAction(types.specsheetSetSpecsheets);
export const specsheetSetSpecsheet = createAction(types.specsheetSetSpecsheet);
export const specsheetHandleForm = createAction(types.specsheetHandleForm);
export const specsheetSaved = createAction(types.specsheetSaved);
export const specsheetSelectSpanType = createAction(types.specsheetSelectSpanType);
export const specsheetSelect = createAction(types.specsheetSelect);
export const specsheetTakePhoto = createAction(types.specsheetTakePhoto);
export const specsheetGalleryPhoto = createAction(types.specsheetGalleryPhoto);
export const specsheetDeletePhoto = createAction(types.specsheetDeletePhoto);
export const specsheetPhotoDeleted = createAction(types.specsheetPhotoDeleted);
export const specsheetSavePhoto = createAction(types.specsheetSavePhoto);
export const specsheetPhotoSaved = createAction(types.specsheetPhotoSaved);
export const specsheetSetCurrentImage = createAction(types.specsheetSetCurrentImage);
export const specsheetSVGClick = createAction(types.specsheetSVGClick);
export const specsheetSetOpenDropdown = createAction(types.specsheetSetOpenDropdown);
export const specsheetSVGClickOpen = createAction(types.specsheetSVGClickOpen);
export const specsheetSetActiveTabKey = createAction(types.specsheetSetActiveTabKey);
export const specsheetToggleOvalPreview = createAction(types.specsheetToggleOvalPreview);
export const specsheetCalculateThumbCuts = createAction(types.specsheetCalculateThumbCuts);
export const specsheetAddThumbCut = createAction(types.specsheetAddThumbCut);
export const specsheetUpdateThumbCut = createAction(types.specsheetUpdateThumbCut);
export const specsheetDeleteThumbCut = createAction(types.specsheetDeleteThumbCut);
export const specsheetSetThumbCuts = createAction(types.specsheetSetThumbCuts);
export const specsheetSetThumbCutsError = createAction(types.specsheetSetThumbCutsError);
export const specsheetAddNew = createAction(types.specsheetAddNew);
export const specsheetClone = createAction(types.specsheetClone);
export const specSheetRemove = createAction(types.specSheetRemove);
export const specSheetRemoved = createAction(types.specSheetRemoved);
export const specSheetNoteState = createAction(types.specSheetNoteState);

export const INITIAL_STATE = {
  saving: false,
  currentSpecSheet: {},
  specsheets: [],
  selectedSpan: 'full',
  images: [],
  currentImageIndex: 0,
  openDropdown: '',
  activeTabKey: '1',
  hideRulerBadge: false,
  hideFingerBadge: false,
  hideThumbBadge: false,
  hideNotesBadge: false,
  tabChange: false,
  isOvalPreviewOpen: false,
  thumbCuts: [],
  thumbCutsError: '',
  noteEditorState: EditorState.createEmpty(),
};

const rulerFields = [
  'name',
  'hand',
  'ball_grip',
  'f1_span_full',
  'f1_span_cut',
  'f1_span_outer2_cut',
  'f2_span_full',
  'f2_span_cut',
  'f2_span_outer2_cut',
];

const fingerFields = [
  'f1_lat',
  'f1_rev',
  'f1_for',
  'f1_grip_type',
  'f1_size',
  'f1_od',
  'bridge',
  'clt',
  'f2_lat',
  'f2_rev',
  'f2_for',
  'f2_grip_type',
  'f2_size',
  'f2_od',
];

const thumbFields = [
  'thm_flex',
  'thm_lat_l',
  'thm_for',
  'thm_rev',
  'thm_lat_r',
  'thm_insert_type',
  'thm_type',
  'thm_size',
  'thm_round_taper',
  'thm_oval_starting_bit',
  'thm_oval_width',
  'thm_oval_degree',
  'thm_od',
  'thm_oval_taper',
];

const activeTabKeyChecker = openDropdown => {
  const tabKeyFields = {
    '1': R.indexOf(R.__, rulerFields),
    '2': R.indexOf(R.__, fingerFields),
    '3': R.indexOf(R.__, thumbFields),
  };

  return R.pipe(
    R.mapObjIndexed((indexFn, key) => (indexFn(openDropdown) >= 0 ? key : '')),
    R.values(),
    R.filter(val => val !== ''),
    keys => keys[0]
  )(tabKeyFields);
};

const notesFields = ['note'];

export const specsheetReducer = handleActions(
  {
    [types.specsheetSetSpecsheets]: (state, action) => ({
      ...state,
      specsheets: action.payload.specsheets,
    }),
    [types.specsheetUpdateSpecsheets]: (state, action) => ({
      ...state,
      specsheets: action.payload.specsheets,
    }),
    [types.specsheetSetValues]: (state, action) => ({
      ...state,
      currentSpecSheet: action.payload.currentSpecSheet,
      hideRulerBadge:
        R.pipe(
          R.pick(rulerFields),
          R.values,
          R.filter(val => val !== ''),
          R.length
        )(action.payload.currentSpecSheet) > 0,
      hideFingerBadge:
        R.pipe(
          R.pick(fingerFields),
          R.values,
          R.filter(val => val !== ''),
          R.length
        )(action.payload.currentSpecSheet) > 0,
      hideThumbBadge:
        R.pipe(
          R.pick(thumbFields),
          R.values,
          R.filter(val => val !== ''),
          R.length
        )(action.payload.currentSpecSheet) > 0,
      hideNotesBadge:
        R.pipe(
          R.pick(notesFields),
          R.values,
          R.filter(val => val !== ''),
          R.length
        )(action.payload.currentSpecSheet) > 0,
    }),
    [types.specsheetSaved]: state => ({
      ...state,
      specsheetSaved: false,
    }),
    [types.specsheetSetSpecsheet]: (state, action) => ({
      ...state,
      currentSpecSheet: action.payload.specsheet,
      images: action.payload.images,
      thumbCuts: action.payload.thumbCuts,
      currentImageIndex: 0,
      activeTabKey: '1',
      noteEditorState: EditorState.createWithContent(
        ContentState.createFromText(
          action.payload.specsheet && action.payload.specsheet.note ? action.payload.specsheet.note : ''
        )
      ),
      hideRulerBadge: action.payload.specsheet
        ? R.pipe(
            R.pick(rulerFields),
            R.values,
            R.filter(val => val !== ''),
            R.length
          )(action.payload.specsheet) > 0
        : true,
      hideFingerBadge: action.payload.specsheet
        ? R.pipe(
            R.pick(fingerFields),
            R.values,
            R.filter(val => val !== ''),
            R.length
          )(action.payload.specsheet) > 0
        : true,
      hideThumbBadge: action.payload.specsheet
        ? R.pipe(
            R.pick(thumbFields),
            R.values,
            R.filter(val => val !== ''),
            R.length
          )(action.payload.specsheet) > 0
        : true,
      hideNotesBadge: action.payload.specsheet
        ? R.pipe(
            R.pick(notesFields),
            R.values,
            R.filter(val => val !== ''),
            R.length
          )(action.payload.specsheet) > 0
        : true,
    }),
    [types.specsheetSelectSpanType]: (state, action) => ({
      ...state,
      selectedSpan: action.payload.selectedSpan,
    }),
    [types.specsheetPhotoSaved]: (state, action) => ({
      ...state,
      images: [...state.images, action.payload.photo],
      currentImageIndex: state.images.length,
    }),
    [types.specsheetPhotoDeleted]: (state, action) => ({
      ...state,
      images: R.remove(state.currentImageIndex, 1)(state.images),
      currentImageIndex:
        state.currentImageIndex >= state.images.length - 1 ? state.images.length : state.currentImageIndex,
    }),
    [types.specsheetSetCurrentImage]: (state, action) => ({
      ...state,
      currentImageIndex: action.payload.currentImageIndex,
    }),
    [types.specsheetSVGClick]: (state, action) => ({
      ...state,
      activeTabKey: activeTabKeyChecker(action.payload.openDropdown),
      tabChange: activeTabKeyChecker(action.payload.openDropdown) !== state.activeTabKey,
    }),
    [types.specsheetSetOpenDropdown]: (state, action) => ({
      ...state,
      openDropdown: action.payload.openDropdown,
    }),
    [types.specsheetSVGClickOpen]: state => ({
      ...state,
      openDropdown: '',
      tabChange: false,
    }),
    [types.specsheetSetActiveTabKey]: (state, action) => ({
      ...state,
      activeTabKey: action.payload.activeTabKey,
      tabChange: false,
    }),
    [types.specsheetToggleOvalPreview]: state => ({
      ...state,
      isOvalPreviewOpen: !state.isOvalPreviewOpen,
    }),
    [types.specsheetSetThumbCuts]: (state, action) => ({
      ...state,
      thumbCuts: action.payload.thumbCuts,
      isOvalPreviewOpen: !!action.payload.openOvalInfo,
    }),
    [types.specsheetSetThumbCutsError]: (state, action) => ({
      ...state,
      thumbCutsError: action.payload.error,
    }),
    [types.specSheetRemoved]: (state, action) => ({
      ...state,
      specsheets: action.payload.specsheets,
    }),
    [types.specSheetNoteState]: (state, action) => ({
      ...state,
      noteEditorState: action.payload.noteEditorState,
    }),
    [types.specsheetAddNew]: state => ({
      ...state,
      noteEditorState: EditorState.createEmpty(),
    }),
  },
  INITIAL_STATE
);
